import React from 'react'

const DateInput = React.forwardRef((props, ref) => (
  <label className='team-label league-label'>
    {props.label}
    <div className='date-input'>
      <input 
        className='team-control league-control' 
        placeholder='MM/DD/YYYY'
        ref={ref}
        value={props.value}
        onClick={props.onClick} 
        onChange={props.onChange} 
      />
      <img src='/images/leagues/date.png' />
    </div>
    {props.error && <div className='error_container'>{props.error.message}</div>}
  </label>
))

export default DateInput
